<div id="map" #map></div>
<div id="marker" [class.home-icon]="showHomeIcon"></div>
<button *ngIf="showMapTypeControl" id="reset-map" type="button" (click)="onMapReset()" #resetmap>
  <ion-icon name="locate"></ion-icon>
</button>
